import { render, staticRenderFns } from "./AppTextField.vue?vue&type=template&id=4fa884a7&scoped=true"
import script from "./AppTextField.vue?vue&type=script&lang=js"
export * from "./AppTextField.vue?vue&type=script&lang=js"
import style0 from "./AppTextField.vue?vue&type=style&index=0&id=4fa884a7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa884a7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
